import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LoginWithTelegram from './components/LoginWithTelegram'; // Импорт компонента
import HomePage from './components/HomePage'; // Главная страница
import PrivateRoute from './components/PrivateRoute';
import { AppProvider } from './context/AppContext';




function App() {

  return (
    <div className="App">
      <AppProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginWithTelegram />} />
          <Route path="/" element={<PrivateRoute><HomePage /></PrivateRoute>} />
        </Routes>
      </Router>
      </AppProvider>
      
    </div>
  );
}

export default App;